import { get } from 'lodash/fp';

import createReducer from '../utils/createReducer';
import {
  TOGGLE_MOBILE_MENU,
  TOGGLE_CHAT,
  API_CALL_SUCCESS,
  API_CALL_FAILURE,
  SET_IS_WEBVIEW
} from '../constants/actionTypes';

const initialState = {
  isMobileMenuOpen: false,
  isNativeWebView: false,
  isChatOpen: false,
  minVersion: fsgBuild.VERSION,
  minIOSAppVersion: fsgBuild.VERSION
};

function getMinVersion(state, action) {
  return {
    minVersion: get('meta.minimum_frontend_version', action) || state.minVersion,
    minIOSAppVersion: get('meta.minimum_ios_app_version', action) || state.minIOSAppVersion
  };
}

const uiReducer = createReducer(initialState, {
  [TOGGLE_MOBILE_MENU]: state => ({
    isMobileMenuOpen: !state.isMobileMenuOpen
  }),
  [TOGGLE_CHAT]: state => ({
    isChatOpen: !state.isChatOpen
  }),
  [SET_IS_WEBVIEW]: () => ({
    isNativeWebView: true
  }),
  [API_CALL_SUCCESS]: getMinVersion,
  [API_CALL_FAILURE]: getMinVersion
});

export default uiReducer;
